import { Component, Input, OnInit } from "@angular/core";
import { GroupsService } from "../../../../..";
import * as moment from "moment";

@Component({
	selector: "caass-assign-default-actions",
	templateUrl: "./assign-default-actions.component.html",
	styleUrls: ["./assign-default-actions.component.css"],
})
export class AssignDefaultActionsComponent implements OnInit {
	constructor(private GroupActionTableService: GroupsService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadGroupAction();
	}

	ngOnChanges() {
		this.loadGroupAction();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedGroup: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = true;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedGroupAction: any;
	lstGroupAction: any = [];

	//Filter lists
	lstStartDateDesc: any = [];
	lstEndDateDesc: any = [];
	lstGroupActionTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "GroupActionTypeDesc", header: "Action Type" },
		{ field: "Description", header: "Description" },
		{ field: "IncidentDTDesc", header: "Action Date" },
		{ field: "StartDateDesc", header: "Start Date" },
		{ field: "EndDateDesc", header: "End Date" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadGroupAction() {
		if (this.SelectedGroup == undefined) {
			return;
		}

		this.loading = true;

		var result = this.GroupActionTableService.GroupActionsGetListDefault(this.SelectedGroup.GroupID);
		result.subscribe(
			(response) => {
				this.lstGroupAction = response;

				//Load Data Filter Lists
				for (var i = 0; i < this.lstGroupAction.length; i++) {
					var next = this.lstGroupAction[i];

					next.IncidentDTDesc = next.IncidentDT == "0001-01-01T00:00:00" ? "" : moment(new Date(next.IncidentDT)).format("MM/DD/YYYY h:mm a");
					next.StartDateDesc = next.StartDate == "0001-01-01T00:00:00" ? "" : moment(new Date(next.StartDate)).format("MM/DD/YYYY");
					next.EndDateDesc = next.EndDate == "0001-01-01T00:00:00" ? "" : moment(new Date(next.EndDate)).format("MM/DD/YYYY");
				}

				this.lstGroupActionTypeDesc = Array.from(new Set(this.lstGroupAction.map((item: any) => item.GroupActionTypeDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	onRowDblClick(GroupAction) {}
	////////////////////////////////////////////
}
